import React from 'react';

import SuccessMark from '../../images/SuccessMark';
import SignUpForm from '../Form/SignUp';

import style from './SignUp.scss';

import cn from 'classnames';

interface ISignUpBannerProps {
  className?: string;
  btnText?: string;
}

const SignUpBanner = ({ className, btnText }: ISignUpBannerProps) => {
  return (
    <div className={cn(style.signUpBanner, className)}>
      <div className="container">
        <div className="row align-items-end">
          <div className="col-12 col-md-8 col-lg-5 offset-md-2 offset-lg-1">
            <h2>
              Never miss <br />a story
            </h2>
            <p>
              Sign up to be the first to receive the most personal{' '}
              <br className="d-block d-md-none" />
              finance content you won’t find anywhere else.
            </p>
          </div>
          <div className="col-12 col-md-8 col-lg-5  offset-md-2 offset-lg-0">
            <SignUpForm className={style.form} btnText={btnText}>
              {/* Render children on subscribed */}
              <div className={style.successMessage}>
                <SuccessMark />
                <p>
                  Success! Now check your email <br />
                  to confirm your subscription.
                </p>
              </div>
            </SignUpForm>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpBanner;
